import { getDriver } from "@/tours/driverInstance";
import router from '@/router'
import demoImgUrl from '@/assets/img/tour/vehicleSample.png';

export function vehicleListSteps(focusIntoView) {
  const q = (sel) => document.querySelector(sel);
  return [
    {
      element: () => q('[data-tour="dlist.create"]'),
      popover: {
        title: "운송수단 등록",
        side: "center",
        align: "center",
        description: `
          <div style="margin-bottom:32px;"><b>운송수단 등록화면</b>으로 이동합니다.
          </div>
            <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:end;">
              <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
              <button id="go-register" class="driver-popover-next-btn driver-popover-btn">
                이동
              </button>
            </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();
        document.querySelector('#go-register')
          ?.addEventListener('click', () => {
            drv.destroy();
            router.push({ name: 'VehicleCreate' ,query: { tour: 'true', view: 'create' } });
          });
      }
    },
  ];
}


export function vehicleCreateSteps(focusIntoView) {
  const q = (sel) => document.querySelector(sel);
  return [
    {
      element: () => q('[data-tour="dcreate.left"]'),
      popover: {
        title: "상세정보 설정",
        side: "right",
        align: "start",
        popoverClass: 'driver-theme-bs popover-offset-r',
        description: `
         <div class="ds-tip" style="margin-bottom:32px;">
          <div class="item"><span class="num">1</span><div class="txt">
            <div class="tit">대표 이미지</div>
            <div class="desc">
              차량을 쉽게 구분할 수 있는 사진을 등록합니다. (선택)<br/>
              예) 차량 정면/측면 사진, 차고지에서 촬영한 이미지, 회사 로고 부착 사진<br/>
              ※ JPG/PNG 형식, 10MB 이하 권장
            </div>
          </div></div>
          <div class="item"><span class="num">2</span><div class="txt">
            <div class="tit">차량번호 <span class="text-danger">*</span></div>
            <div class="desc">
              법적 <b>차량 등록번호</b>를 입력합니다. 하이픈/공백은 자동으로 무시될 수 있습니다.<br/>
              예) 12가3456, 123가4567, ABC-1234<br/>
            </div>
          </div></div>
          <div class="item"><span class="num">3</span><div class="txt">
            <div class="tit">차량 종류</div>
            <div class="desc">
              실제 운송에 쓰이는 차종을 입력합니다. 배차·필터링에 활용됩니다.<br/>
              예) 트레일러, 탑차, 냉동탑차, 덤프, 승합, 오토바이, 픽업 등
            </div>
          </div></div>
          <div class="item"><span class="num">4</span><div class="txt">
            <div class="tit">연료 종류 <span class="text-danger">*</span></div>
            <div class="desc">
              차량의 주 연료를 선택합니다. <b>거리대비 탄소배출량</b> 계산에 사용됩니다.
            </div>
          </div></div>
        </div>
          <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:end;">
            <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
            <button id="auto-input" class="driver-popover-custom-btn driver-popover-btn">
              다음
            </button>
          </div>
        `,
        showButtons: []
      },
      onHighlighted: async () => {
        const drv = getDriver();

        const sleep = (ms) => new Promise(r => setTimeout(r, ms));
        const typeInto = async (el, text, delay = 25) => {
          if (!el) return;
          el.focus();
          el.value = '';
          el.dispatchEvent(new Event('input', { bubbles: true }));
          for (const ch of text) {
            el.value += ch;
            el.dispatchEvent(new Event('input', { bubbles: true }));
            await sleep(delay);
          }
          el.blur();
        };
        const waitFor = async (selector, timeout = 2000) => {
          const start = performance.now();
          while (performance.now() - start < timeout) {
            const el = document.querySelector(selector);
            if (el) return el;
            await sleep(50);
          }
          return null;
        };

        // 실제 옵션이 있는지 확인하고 change/input 이벤트까지 쏴줌
        const setSelectValue = (el, value) => {
          if (!el) return false;
          const match = [...el.options].find(o => String(o.value) === String(value) && !o.disabled);
          if (!match) return false;
          el.value = match.value;
          [...el.options].forEach(o => (o.selected = (o === match)));
          el.dispatchEvent(new Event('change', { bubbles: true }));
          el.dispatchEvent(new Event('input',  { bubbles: true })); // 안전용
          return true;
        };

        const scopeLeft = '[data-tour="dcreate.left"]';
        const $fuelType = await waitFor(`${scopeLeft} select[data-tour="vehicle.fuelType"]`);
        const $vehicleNo     = document.querySelector(`${scopeLeft} input[placeholder="예: 12가3456 / ABC-1234"]`);
        const $vehicleType     = document.querySelector(`${scopeLeft} input[placeholder="예: 트레일러, 탑차, 냉동탑차 등"]`);

        const setDemoImage = async (url) => {
          const res = await fetch(url);
          const blob = await res.blob();
          const name = (url.split('/').pop() || 'demo.jpg');
          const file = new File([blob], name, { type: blob.type });
          window.dispatchEvent(new CustomEvent('tour:setImage', { detail: { file, blob, name } }));
        };

        const btn = document.querySelector('#auto-input');
        if (!btn) return;

        // ✅ 기존에 붙은 모든 핸들러 제거(Driver의 기본 next 포함 가능성) + 대체
        const clone = btn.cloneNode(true);
        btn.replaceWith(clone);

        let running = false; // 재진입 가드

        const run = async (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (running) return;          // 이미 실행 중이면 무시
          running = true;

          // UI 잠금
          const prevText = clone.textContent;
          clone.disabled = true;
          clone.classList.add('is-busy');

          try {
            await sleep(50);
            await setDemoImage(demoImgUrl);
            setSelectValue($fuelType, 'DIESEL');
            await typeInto($vehicleNo, '경북12가3456', 10);
            await typeInto($vehicleType, '트레일러', 10);

            await sleep(1700);
            drv.moveNext();            // 완료 후 다음 스텝
          } finally {
            // 필요 시 다시 활성화 (다음 스텝으로 넘어가니 의미 없으면 생략 가능)
            clone.disabled = false;
            clone.textContent = prevText;
            clone.classList.remove('is-busy');
            running = false;
          }
        };

        // 한 개의 리스너만 등록
        clone.addEventListener('click', run);
      }
    },
    {
      element: () => q('[data-tour="dcreate.fuel"]'),
      popover: {
        title: "탄소배출량 설정",
        side: "top",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li><b>슬라이더</b>를 드래그해 차량의 평균 연비(<b>km/L</b>)를 설정합니다.</li>
          <li><b>현재</b> 값은 실시간으로 표시되며, 기본 범위는 <b>1 ~ 30 km/L</b> 입니다.</li>
          <li>값이 <b>높을수록</b> 연료 효율이 좋고, 같은 주행거리 대비 <b>탄소배출량이 감소</b>합니다.</li>
          <li>배출량 계산식에 직접 반영됩니다: <b>(주행거리 ÷ 연비) × 연료별 배출계수</b>.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dcreate.fuel"]'),
    },
    {
      element: () => q('[data-tour="dcreate.right"]'),
      popover: {
        title: "탄소배출량 설정",
        side: "left",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li><b>슬라이더</b>를 드래그해 주행 시 <b>탄소배출량(kgCO₂/km)</b>을 설정합니다.</li>
          <li><b>현재</b> 값은 실시간으로 표시되며 기본 범위는 <b>0 ~ 3 kgCO₂/km</b>입니다.</li>
          <li><b>색상 구간</b>은 배출량 수준을 의미합니다. (녹색=낮음, 노랑=보통, 빨강=높음)</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dcreate.co2"]'),
    },
    {
      element: () => q('[data-tour="dcreate.save"]'),
      popover: {
        title: "저장하기",
        side: "top",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li>해당 내용으로 데이터를 <b>저장</b>합니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dcreate.save"]'),
    },
    {
      element: null,
      popover: {
        title: "다음 가이드로 이동",
        side: "center",
        align: "center",
        description: `
          <div style="margin-bottom:32px;"><b>이벤트 생성메뉴</b>로 이동하시겠어요?</div>
          <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:center;">
            <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
            <button id="go-register" class="driver-popover-next-btn driver-popover-btn">
              이동
            </button>
          </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();
        document.querySelector('#go-register')
          ?.addEventListener('click', () => {
            drv.destroy();
            router.push({ name: 'EventCreate' ,query: { tour: 'true' } });
          });
      }
    },
  ];
}
